import {createAction} from 'redux-actions';
import {push} from 'connected-react-router';
import {batchActions} from "redux-batched-actions";
import {mediaPhotoStateSelector} from "./selectors";
import {
    createLlamaStateSelector,
    createStickerIdSelector,
} from '../create-llama/selectors';
import {setPreparedMedia} from '../create-llama/actions';
import cacheManager from '../../domain/services/StickerCache';
import fileUploader from "../../../upload/FileUploader";
import StickerItemsRepositoryBuilder from '../../domain/factories/StickerItemsRepositoryBuilder';
import {getCookie} from '../../../../infrastructure/helpers';
import * as Noty from 'noty';
import {setGeneratingLoaderProgress} from "../../../layout/store/actions";

import authService from "../../../auth/domain/services/AuthService";
import {isCurrentUserLoggedSelector, currentUserSelector} from '../../../auth/store/auth-user/selectors';

const namespace = 'MEDIA_PHOTO';

export const setOriginPhoto = createAction(`${namespace}/SET_ORIGIN_PHOTO`);
export const setResultPhoto = createAction(`${namespace}/SET_RESULT_PHOTO`);
export const setLayoutSize = createAction(`${namespace}/SET_LAYOUT_SIZE`);
export const restorePhoto = createAction(`${namespace}/RESTORE_STATE`);

export function photoDone(canvasesInfo) {
    return (dispatch, getState) => {
        const mediaState = mediaPhotoStateSelector(getState());
        const stickerId = createStickerIdSelector(getState());
        const stickerState = createLlamaStateSelector(getState());

        const uploadPhotoPromise = () => {
            uploadPhoto(dispatch, getState)
                .then((uploadedPhoto) => {
                    cacheManager.cacheUploadedMedia(stickerState, uploadedPhoto);
                    dispatch(setPreparedMedia(uploadedPhoto));
                })
                .then(() => {
                    fileUploader.onUploadComplete && fileUploader.onUploadComplete()
                })
        };

        dispatch(batchActions([
            setResultPhoto({uri: mediaState.originPhotoPath, blob: mediaState.originPhotoInfo.blob}),
            push(`/stickers/${stickerId}/new/preview`)
        ]));
        cacheManager.cacheMediaAsBlob(createLlamaStateSelector(getState()), mediaPhotoStateSelector(getState()));
        if (isCurrentUserLoggedSelector(getState())) {
            uploadPhotoPromise();
        } else {
            authService.signInAnonymously()
                .then(() => {
                    fileUploader.isUploading = true;
                    uploadPhotoPromise();
                });
        }
    };
}

export function uploadPhoto(dispatch, getState) {
    const {resultPhotoInfo} = mediaPhotoStateSelector(getState());
    const stickerState = createLlamaStateSelector(getState());

    const folderName = stickerState.scannedSticker.id;

    const accessToken = getCookie('accessToken');

    return StickerItemsRepositoryBuilder
        .buildWithStickerId(stickerState.scannedSticker.sticker_id)
        .canCurrentUserWriteInStickerItem(stickerState.scannedSticker, accessToken)
        .then(() =>
            currentUserSelector(getState()).getIdToken(true)
                .then((token) => {
                    authService.setAuthTokenInHeaders(token)
                })
                .then(() =>
                    fileUploader.upload(resultPhotoInfo.blob, {folderName}, (progress) => {
                        dispatch(setGeneratingLoaderProgress(progress));
                    })
                        .then((result) => {
                            dispatch(setGeneratingLoaderProgress(null));
                            return {
                                original: result,
                                thumbnail: result,
                            };
                        })
                )
        )
        .catch((error) => {
            new Noty({
                type: 'error',
                timeout: 3000,
                text: `Sticker access error`,
            }).show();
        });
}
